import React from "react";
import ReactGA from "react-ga";
import {Redirect} from "react-router";

import "./../../css/gallery.css";

export class GalleryComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirectTo: ""
        };

        this.disableContextMenu = this.disableContextMenu.bind(this);
        this.handleViewGalleryClick = this.handleViewGalleryClick.bind(this);
    }

    disableContextMenu(event) {
        event.preventDefault();
    }

    handleViewGalleryClick() {
        this.setState({redirectTo: "/gallery/landscape"});
    }

    render() {
        if (this.state.redirectTo) {
            // Tracking
            ReactGA.event({
                category: "Navigation",
                action: "Click",
                label: "view-gallery-button"
            });

            return <Redirect push to={this.state.redirectTo} />;
        }

        return (
            <section id="gallery-component">
                <div className="parallax-1" onContextMenu={this.disableContextMenu}></div>
                <div className="photo-wrapper" onContextMenu={this.disableContextMenu}>
                    <div className="section-photo top"></div>
                </div>
                <div className="container">
                    <div className="header">Gallery</div>
                    <div className="content-box">
                        <div>Explore and view the entire collection of fine art photographs by Wilson Ng.</div>
                        <button className="large" onClick={this.handleViewGalleryClick}>View Gallery</button>
                    </div>
                </div>
                <div className="photo-wrapper" onContextMenu={this.disableContextMenu}>
                    <div className="section-photo bottom"></div>
                </div>
                <div className="parallax-2" onContextMenu={this.disableContextMenu}></div>
            </section>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Scroll/GalleryComponent.js